import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { 
  groupTipsByAuthor,
  getExternalRideIdsFromTipsData,
  generateRidesTipBettingData 
} from './tipUtils';

import AuthorTile from './components/AuthorTile';
import RacingTip from './components/RacingTip';
import { loadRides } from 'modules/HorseRacing/reducers/rides';
import { isMobile } from 'react-device-detect';

require('./TipsWidget.scss');

const ROOT_CLICK_EVENT_NAME = '[In Article Tips]';

export class PureTipsWidget extends Component {
  static contextTypes = {
      metrics: PropTypes.object
  }

  constructor(props) {
      super(props);

      const tips = JSON.parse(this.props.tips);
      this.state = {
        tips,
        tipRideData: new Map(),
        rideIds: getExternalRideIdsFromTipsData(tips)
      };

      this.onAuthorNameClick = this.onAuthorNameClick.bind(this);
      this.onOddsClick = this.onOddsClick.bind(this);
      this.onRaceCardLinkClick = this.onRaceCardLinkClick.bind(this);
      this.onMobileTipHorizontalSwipe = this.onMobileTipHorizontalSwipe.bind(this);
  }

  componentDidMount() {
    if (this.state.rideIds && this.state.rideIds.length > 0) {
      this.props.loadRides(this.state.rideIds);
    }
  }

  onTrackClick(link) {
      if (!this.context.metrics || !this.context.metrics.track) {
          return;
      }

      this.context.metrics.track("linkClick", {link});
  }

  onRaceCardLinkClick() {
      this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Tip Click`);
  }

  onOddsClick() {
      this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Odds Click`);
  }

  onAuthorNameClick() {
      this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Author Click`);
  }

  onMobileTipHorizontalSwipe() {
      this.onTrackClick(`${ROOT_CLICK_EVENT_NAME} Tip Swipe`);
  }

  static getDerivedStateFromProps(props, state) {
    const tips = JSON.parse(props.tips);
    const rideIds = getExternalRideIdsFromTipsData(tips);
    // Load any new ride IDs
    const newRideIds = props.rideIds ? props.rideIds.filter((r) => !state.rideIds.includes(r)) : [];
    if (newRideIds.length > 0) {
      props.loadRides(newRideIds);
    }

    return {
      tips,
      rideIds,
      tipRideData: generateRidesTipBettingData(props.rides, rideIds)
    };
  }

  render() {
    const groupedTips = groupTipsByAuthor(this.state.tips);

    if (!groupedTips) {
      return null;
    }

    return(
      <div className="tips-widget">
          {
              Object.keys(groupedTips).map((author, idx) => {
                  const tips = groupedTips[author];
                  const {
                      author_name = 'SportingLife',
                      author_type = 'Tipster',
                      author_image = ''
                  } = tips[0];

                  const hasLargeTip = (tips.length % 2) > 0;
                  const key = `${author}-${idx}`;

                  if (!this.state.tipRideData || this.state.tipRideData.size == 0) {
                    return null;
                  }

                  return (
                      <div key={key} className="tips-widget__author-tips">
                          <span onClick={this.onAuthorNameClick} >
                            <AuthorTile
                                name={author_name}
                                type={author_type}
                                image={author_image}
                            />
                          </span>
                          <div className={`tips-widget__tips-list ${tips.length % 2 !== 0 ? 'tips-widget__tips-list--odd' : ''}`}>
                              {
                                  tips.map((tip, index) => {
                                      const isLarge = hasLargeTip && index === 0 && !isMobile;
                                    
                                      switch(tip.tip_type) {
                                      case 'racing':
                                          const ride = this.state.tipRideData && this.state.tipRideData.size > 0? this.state.tipRideData.get(Math.trunc(tip.sport_link)) : null;
                                          const imageSet = this.props.media[tip.image_id];
                                          return <RacingTip
                                            key={tip.id} tip={tip}
                                            ride={ride}
                                            isLarge={isLarge}
                                            imageSet={imageSet}
                                            onRaceCardLinkClick={this.onRaceCardLinkClick}
                                            onOddsClick={this.onOddsClick} />;
                                      default:
                                          return null;
                                      }
                                  })
                              }
                          </div>
                      </div>
                  );
              })
          }
      </div>
    );
  }
}

PureTipsWidget.propTypes = {
    tips: PropTypes.string,
    loadRides: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
      rides: state.horseRacing.rides.races,
      media: state.common.media
    };
}

const mapDispatchToProps = dispatch => {
    return {
        loadRides: (rideIds) => dispatch(loadRides(rideIds))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PureTipsWidget);



// WEBPACK FOOTER //
// ./modules/Common/components/TipsWidget/TipsWidget.js